import React from 'react';
import logoImage from '../assets/logo_top_quality_rounded.png';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../constants';

const Footer = ({ navigateTo }) => {
    const colors = {
        accent3: '#f79a6b',
    };

    return (
        <footer className="bg-gradient-to-r from-accent2 to-primary text-white py-12 px-8">
            <div className="max-w-6xl mx-auto">
                <div className="flex flex-col md:flex-row justify-between">
                    <div className="mb-8 md:mb-0">
                        <div className="mb-4">
                            <div className="flex items-center justify-start">
                                <div className="mr-3">
                                    <img src={logoImage} alt="ALE Logo" className="w-16 h-16 rounded-full mx-auto mb-4" />
                                </div>
                                <div>
                                    <h3 className="text-4xl font-bold tracking-wider" style={{ fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.1em' }}>ALE</h3>
                                    <p className="text-sm tracking-widest" style={{ color: colors.accent3 }}>ASK. LISTEN. EXPLORE.</p>
                                </div>
                            </div>
                        </div>
                        <p className="text-sm max-w-sm">The future of self-guided tourism. All the benefits of a private guide — none of the group tour restrictions.</p>
                        <p className="text-sm mt-4">&copy; 2026 by ALE. All Rights Reserved.</p>
                    </div>

                    <div>
                        <h4 className="text-lg font-bold mb-4">Contact</h4>
                        <p className="mb-4">support@ale.tours</p>
                        <h4 className="text-lg font-bold mb-4">Get the App</h4>
                        <div className="flex flex-col space-y-2">
                            <a href={APP_STORE_URL} target="_blank" rel="noreferrer" className="hover:text-accent3 transition duration-300">App Store</a>
                            <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer" className="hover:text-accent3 transition duration-300">Google Play</a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-lg font-bold mb-4">Quick Links</h4>
                        <ul className="space-y-2">
                            <li>
                                <button
                                    onClick={() => navigateTo('home')}
                                    className="hover:text-accent3 transition duration-300"
                                >
                                    Home
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => navigateTo('about')}
                                    className="hover:text-accent3 transition duration-300"
                                >
                                    About Us
                                </button>
                            </li>
                            <li>
                                <button
                                    onClick={() => navigateTo('support')}
                                    className="hover:text-accent3 transition duration-300"
                                >
                                    Support
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-8 pt-8 border-t border-gray-700 text-sm">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <button
                            onClick={() => navigateTo('terms')}
                            className="hover:text-accent3 transition duration-300 relative z-10 px-4 py-2"
                        >
                            Terms of Use
                        </button>
                        <div className="flex space-x-4 relative z-10">
                            <a href="https://www.linkedin.com/company/ale-tours" className="text-white hover:text-accent3" target="_blank" rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-linkedin"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
                            </a>
                            <a href="https://x.com/AleTours11" className="text-white hover:text-accent3" target="_blank" rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather"><path d="M4 4l11.733 16h4.267l-11.733 -16z"></path><path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772"></path></svg>
                            </a>
                            <a href="https://www.instagram.com/ask.listen.explor/" className="text-white hover:text-accent3" target="_blank" rel="noreferrer">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-instagram"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                            </a>
                        </div>
                        <button
                            onClick={() => navigateTo('delete-account')}
                            className="hover:text-accent3 transition duration-300 relative z-10 px-4 py-2"
                        >
                            Delete Account
                        </button>
                        <button
                            onClick={() => navigateTo('privacy')}
                            className="hover:text-accent3 transition duration-300 relative z-10 px-4 py-2"
                        >
                            Privacy Policy
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;